<template>
    <filter-fields :is-actions="isActions" @refresh="refreshFilter" class="ds-filter relative">
        <template #actions>
            <slot name="actions" />
        </template>
        
        <div v-if="loader" class="flex justify-center loader">
            <c-loader color="rgba(var(--vs-primary))"/>
        </div>

        <vs-row vs-type="flex" vs-align="end">
            <slot></slot>
            <vs-col
                v-for="(item, index) of fieldsList"
                :key="index"
                v-if="item.hasOwnProperty('display') ? isPermission(item.can) && item.display : isPermission(item.can)"
                :vs-w="item.full ? 12 : 12"
                :vs-sm="item.full ? 12 : 6"
                :vs-lg="item.full ? 12 : 3"
                :vs-xs="item.full ? 12 : 12"
            >
                <div class="m-2" v-if="item.type === 'input'"
                     :class="{
                        selected: selected[item.field] && !item.notClearBtn
                    }"
                >
                    <label class="text-sm opacity-75">{{ $t(item.name) }}{{ item.required ? '*' : '' }}</label>
                    <vs-input
                        class="inputx w-full no_focus"
                        :placeholder="$t(item.name)"
                        v-model="selected[item.field]"
                        :disabled="disabled"
                    />
                </div>

                <div class="m-2" v-if="item.type === 'select' && !ssr"
                     :class="{
                        selected: selected[item.field] && !item.notClearBtn,
                        notClear: item.notClearBtn && item.multiple && selected[item.key || item.field] && selected[item.key || item.field].length === 1
                    }"
                >
                    <label class="text-sm opacity-75">{{ $t(item.name) }}{{ item.required ? '*' : '' }}</label>
                    <v-select
                        :options="options[item.key || item.field]"
                        :reduce="a => a.id || a.value"
                        label="label"
                        :multiple="item.multiple"
                        :placeholder="$t(item.name)"
                        :clearable="true"
                        v-model="selected[item.key || item.field]"
                        @input="selectField"
                        @open="openField(item.key || item.field)"
                        :disabled="disabled"
                    />
                </div>

                <div class="m-2" v-if="item.type === 'select' && ssr"
                     :class="{
                        selected: selected[item.field] && !item.notClearBtn,
                        notClear: item.notClearBtn && item.multiple && selected[item.key || item.field] && selected[item.key || item.field].length === 1
                    }"
                >
                    <label class="text-sm opacity-75">{{ $t(item.name) }}{{ item.required ? '*' : '' }}</label>
                    <v-select
                        :options="options[item.field]"
                        :reduce="a => a.id"
                        :selectable="a => a.disabled"
                        label="name"
                        :multiple="item.multiple"
                        :closeOnSelect="!item.multiple"
                        :placeholder="$t(item.name)"
                        :clearable="false"
                        v-model="selected[item.key || item.field]"
                        @input="selectField(item.field)"
                        :disabled="disabled"
                    />
                </div>
            </vs-col>

            <vs-col vs-w="12" v-if="ssr">
                <vs-row vs-type="flex" vs-align="end" vs-justify="end">
                    <vs-col
                        vs-w="12"
                        vs-sm="6"
                        vs-lg="3"
                        vs-xs="12"
                        v-for="(item, index) of footerFields"
                        :key="index"
                        v-if="isPermission(item.can) && footerFields.length"
                    >
                        <div class="m-2" v-if="item.type === 'input'"
                             :class="{
                                selected: selected[item.field] && !item.notClearBtn
                            }"
                        >
                            <label class="text-sm opacity-75">{{ $t(item.name) }}{{ item.required ? '*' : '' }}</label>
                            <vs-input
                                class="inputx w-full no_focus"
                                :placeholder="$t(item.name)"
                                v-model="selected[item.field]"
                                :disabled="disabled"
                            />
                        </div>

                        <div class="m-2" v-if="item.type === 'select' && !ssr"
                             :class="{
                                selected: selected[item.field] && !item.notClearBtn,
                                notClear: item.notClearBtn && item.multiple && selected[item.key || item.field] && selected[item.key || item.field].length === 1
                            }"
                        >
                            <label class="text-sm opacity-75">{{ $t(item.name) }}{{ item.required ? '*' : '' }}</label>
                            <v-select
                                :options="options[item.key || item.field]"
                                :reduce="a => a.id || a.value"
                                label="label"
                                :multiple="item.multiple"
                                :placeholder="$t(item.name)"
                                :clearable="false"
                                v-model="selected[item.key || item.field]"
                                @input="selectField"
                                @open="openField(item.key || item.field)"
                                :disabled="disabled"
                            />
                        </div>

                        <div class="m-2" v-if="item.type === 'select' && ssr"
                             :class="{
                                selected: selected[item.field] && !item.notClearBtn,
                                notClear: item.notClearBtn && item.multiple && selected[item.key || item.field] && selected[item.key || item.field].length === 1
                            }"
                        >
                            <label class="text-sm opacity-75">{{ $t(item.name) }}{{ item.required ? '*' : '' }}</label>
                            <v-select
                                :options="options[item.field]"
                                :reduce="a => a.id"
                                :selectable="a => a.disabled"
                                label="name"
                                :multiple="item.multiple"
                                :closeOnSelect="!item.multiple"
                                :placeholder="$t(item.name)"
                                :clearable="false"
                                v-model="selected[item.key || item.field]"
                                @input="selectField(item.field)"
                                :disabled="disabled"
                            />
                        </div>
                    </vs-col>

                    <vs-col
                        v-if="isActions"
                        vs-w="12"
                        :vs-sm="isFooterFull ? 12 : 6"
                        :vs-lg="isFooterFull ? 12 : 3"
                        vs-xs="12"
                    >
                        <div class="flex justify-between items-center">
                            <div class="m-2">
                                <slot name="footer"></slot>
                            </div>
                            <div class="m-2">
                                <vs-button
                                    :disabled="loaded || disabled || disabledSubmit"
                                    color="primary"
                                    @click="submitFilter"
                                    type="filled"
                                >
                                    {{ $t('buttons.Filter') }}
                                </vs-button>
                            </div>
                        </div>
                    </vs-col>
                </vs-row>
            </vs-col>
        </vs-row>
        <slot v-if="!ssr" name="footer"></slot>
    </filter-fields>
</template>

<script>
import vSelect from "vue-select";
import ErrorHandler from "@/utils/errorHandler"
import {checkPermission} from '@/utils/mixins'

export default {
    name: 'ds-filter',

    mixins: [checkPermission],

    props: {
        isReturnFullData: {
            type: Boolean,
            default: false
        },
        selectData: {
            type: Object,
            default: () => ({})
        },
        isActions: {
            type: Boolean,
            default: true
        },
        loader: {
            type: Boolean,
            default: false
        },
        fields: {
            type: Array | Object,
            required: true
        },
        data: {
            type: Array | Object,
            default: () => []
        },
        reset: {
            type: Boolean,
            default: true
        },
        isFooterFull: {
            type: Boolean,
            default: false
        },
        defaultData: {
            type: Object,
            default: () => {}
        },
        ssr: {
            type: Boolean,
            default: false
        },
        loaded: {
            type: Boolean,
            default: false
        },
        disabledReloadBtn: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledSubmit: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            disabledReset: true,
            dataList: [],
            options: {},
            selected: {},
            footerFields: [],
            fieldsList: []
        }
    },

    components: {
        vSelect
    },

    watch: {
        data: {
            handler(data) {
                this.createFields()

                if (this.ssr) {
                    this.createOptionsSSR(data)
                } else {
                    this.createOptions(data)
                    this.selectField()
                }
            },
            deep: true
        },

        selected: {
            handler(data) {
                for (const [key, value] of Object.entries(data)) {
                    if ((typeof value === 'string' || Array.isArray(value)) && !value.length) delete this.selected[key]
                }

                const values = Object.values(this.selected).filter(item => item)
                this.disabledReset = !values.length

                this.$emit('select', data)
            },
            deep: true
        },
    },

    mounted() {
        this.createFields()

        if (this.ssr) {
            this.createOptionsSSR(this.data)
        } else {
            this.createOptions(this.data)
            this.selectField()
        }

        if (!Object.keys(this.selected).length && this.defaultData) {
            this.selected = this.copy(this.defaultData)
        }

        if (Object.keys(this.selectData).length) {
            this.createHistory()
        }
    },

    methods: {
        createHistory() {
            const fieldsInfo = this.fields.reduce((info, item) => {
                const key = item.reKey || item.field
                if (item.type === 'input' || item.type === 'select') {
                    if (!item.multiple) {
                        info['input'][key] = item.field
                    } else {
                        info[item.type][key] = item.field
                    }
                }
                return info
            }, {input: {}, select: {}})

            this.selected = Object.keys(this.selectData).reduce((acc, key) => {
                const field = fieldsInfo.input[key] || fieldsInfo.select[key] || key
                acc[field] = fieldsInfo.input[key] ? this.selectData[key].join(' ') : this.selectData[key]
                return acc
            }, {})

            Object.entries(this.selectData).forEach(([key, value]) => {
                const _key = fieldsInfo.select[key]
                if (_key) {
                    const dataValuesSet = this.data[_key].map(item => item.id || item)
                    this.selected[_key] = value.filter(item => dataValuesSet.includes(item))
                }
            })
        },

        createFields() {
            if (this.isObject(this.fields)) {
                this.footerFields = this.fields.footer
                this.fieldsList = this.fields.fields
            } else {
                this.fieldsList = this.fields
            }
        },

        isObject(element) {
            return typeof element === 'object' && element !== null && !Array.isArray(element)
        },

        getTemplateField() {
            return Array.isArray(this.fields)
                ? this.fields.map(item => ({ [item.field]: item.reKey || item.field }))
                : Object.keys(this.fields).flatMap(key =>
                    this.fields[key].map(item => ({ [item.field]: item.reKey || item.field }))
                )
        },

        returnKey(item, key) {
            const fields = Array.isArray(this.fields) ? this.fields : Object.values(this.fields).flat()

            const field = fields.find(a => (a.reKey || a.field) === key)

            if (field) {
                return item.flatMap(a => this.options[key]
                    .filter(option => (option.id || option.value) === a)
                )
            }

            return item
        },

        submitFilter() {
            let template = this.getTemplateField()

            Object.keys(this.selected).map(key => {
                if (!Number.isInteger(this.selected[key])) {
                    if (!this.selected[key] || !this.selected[key].length)
                        delete this.selected[key]
                }
            })

            this.$emit('submit', Object.keys(this.selected).reduce((res, key) => {
                const _key = template.find(item => item[key])[key]

                res[_key] = this.isReturnFullData ?
                    this.returnKey(this.selected[key], key) :
                    this.selected[key]

                return res
            }, {}))
        },

        sortData(data, key) {
            const sort = (a, b) => {
                if (typeof a[key] === 'string') {
                    if (a[key].toLowerCase() < b[key].toLowerCase()) return -1
                } else {
                    if (~~a[key] < ~~b[key]) return -1
                }
            }

            data.sort(sort)
        },

        getFieldKey(key) {
            return [...this.fieldsList, ...this.footerFields].find(item => item.key === key)
        },

        copy(data) {
            return JSON.parse(JSON.stringify(data))
        },

        resetFilter() {
            this.$set(this, 'selected', {})
        },

        setDefaultsFilter(data) {
            this.selected = data
        },

        refreshFilter(bool = true, params = {}) {
            if (!this.reset && bool) {
                this.$emit('reset')
            } else {
                if (this.defaultData) {
                    this.selected = this.copy(this.defaultData)
                } else {
                    this.selected = {}
                }

                if (!this.ssr) {
                    this.selectField()
                    this.$emit('updateFilterFields')
                } else {
                    this.$emit('resetFilter', params)
                }
            }
        },

        removingEmptyKeys(obj) {
            Object.keys(obj).map(key => {
                if (
                    obj[key] === '' ||
                    obj[key] === undefined ||
                    obj[key] === null
                ) delete obj[key]
            })

            return obj
        },

        openField(key) {
            const params = this.removingEmptyKeys(this.copy(this.selected))
            delete params[key]

            this.selectField(params)
        },

        selectField(newParam) {
            if (this.ssr) {
                const param = this.selected[newParam]

                if (!Number.isInteger(param)) {
                    if (!param || !param.length) {
                        delete this.selected[newParam]
                    }
                }
            } else {
                const params = this.removingEmptyKeys(this.copy(this.selected))

                if (Object.isObject(newParam)) {
                    this.createOptions(this.filteringData(this.data, newParam))
                } else {
                    const data = this.filteringData(this.data, params)
                    this.createOptions(data)
                    this.$emit('resultFilter', data)

                    if (newParam !== undefined) {
                        this.$emit('updateFilterFields')
                    }
                }
            }
        },

        transformParams(param) {
            return !Array.isArray(param) ? [param] : param
        },

        filteringData(data, params) {
            try {
                return data.filter(item => Object.keys(params).every(key => {
                    const param = this.transformParams(params[key])
                    const field = this.getFieldKey(key)

                    if (!field) {
                        return param.includes(item[key])
                    } else {
                        let bool = false

                        const search = object => {
                            if (object[key]) {
                                if (Object.isObject(object[key])) {
                                    if (param.includes(object[key][field.field])) bool = true
                                }

                                if (Array.isArray(object[key])) {
                                    const elem = object[key].filter(el => param.includes(el[field.field]))
                                    if (elem.length) bool = true
                                }
                            } else {
                                Object.keys(object).map(objectKey => {
                                    if (Array.isArray(object[objectKey])) object[objectKey].map(i => search(i))
                                })
                            }
                        }

                        search(item)
                        if (bool) return item
                    }
                }))
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        createNameById(data) {
            return Object.entries(data).reduce((acc, [key, val]) => {
                acc[key] = val.map(item => ({
                    ...item,
                    name: this.isObject(item) ? (item.name || item.id).toString() : item
                }))

                return acc
            }, {})
        },

        changeData(options, newOptions, selected) {
            let updatedOptions = this.copy(options)

            const allKeys = new Set([...Object.keys(options), ...Object.keys(newOptions), ...Object.keys(selected)])

            allKeys.forEach(key => {
                if (!updatedOptions[key]) updatedOptions[key] = []

                if (!selected[key] || selected[key].length === 0) {
                    updatedOptions[key] = newOptions[key] ? this.copy(newOptions[key]) : []
                    return
                }

                const mapB = new Map((newOptions[key] || []).map(item => [item.id, item]))

                updatedOptions[key] = updatedOptions[key].map(item => {
                    return mapB.has(item.id) ? { ...item, disabled: true } : { ...item, disabled: false }
                })

                if (newOptions[key]) {
                    newOptions[key].forEach(itemB => {
                        if (!updatedOptions[key].some(itemA => itemA.id === itemB.id)) {
                            updatedOptions[key].push(itemB)
                        }
                    })
                }
            })

            return updatedOptions
        },

        createOptions(data) {
            const options = {}

            const optionsPush = (name, label, value) => {
                const some = options[name].some(i => i.label === label)
                if (!some) options[name].push({label, value})
            }

            try {
                data.map(item => {
                    this.fields.map(field => {
                        const key = field.key || field.field

                        if (!this.selected[key]) this.$set(this.selected, key, '')
                        if (!options[key]) options[key] = []

                        if (!field.key) {
                            optionsPush(key, item[field.label], item[field.field])
                        } else {

                            const fn = data => {
                                if (data[key]) {
                                    if (Array.isArray(data[key])) {
                                        data[key].map(s => optionsPush(key, s[field.label], s[field.field]))
                                    } else if (Object.isObject(data[key])) {
                                        optionsPush(key, data[key][field.label], data[key][field.field])
                                    }
                                } else {
                                    Object.keys(data).map(k => {
                                        if (Array.isArray(data[k])) data[k].map(s => fn(s))
                                    })
                                }
                            }

                            fn(item)
                        }
                    })
                })

                Object.keys(options).map(k => {
                    const field = this.fields.find(item => {
                        const key = item.key || item.field
                        return key === k
                    })

                    this.sortData(options[k], field.sortKey ? field.sortKey : 'label')
                })

                this.options = options
            } catch (e) {
                new ErrorHandler(e).send
            }
        },

        createOptionsSSR(data) {
            const list = this.createNameById(this.mutationDataSSR(data))

            Object.entries(list).forEach(([key, value]) => {
                let field

                if (this.fields.fields) {
                    field = this.fields.fields.find(item => item.field === key)
                } else {
                    field = this.fields.find(item => item.field === key)
                }

                if (field) {
                    const sortKey = !!(field && field.sоrtKey) ? field.sоrtKey : 'name'

                    list[key] = value.sort((a, b) => {
                        let ax = a[sortKey]
                        let bx = b[sortKey]

                        if (typeof ax === 'string' && typeof bx === 'string') {
                            ax = ax.toLowerCase()
                            bx = bx.toLowerCase()
                        }

                        return ax < bx ? -1 : 1
                    })
                }
            })

            this.options = this.changeData(this.options, list, this.selected)

            Object.keys(this.options).forEach(key => {
                this.options[key].sort((a, b) => (a.disabled === b.disabled) ? 0 : a.disabled ? -1 : 1)
            })
        },

        mutationDataSSR(data) {
            return Object.entries(data).reduce((res, [key, value]) => {
                res[key] = value.map(item => {
                    if (this.isObject(item)) {
                        item.disabled = true
                    } else if ((typeof item === 'string' || typeof item === 'number') && item !== '') {
                        item = {name: item, id: item, disabled: true}
                    }

                    return item
                }).filter(item => item)

                return res
            }, {})
        }
    }
}
</script>

<style lang="scss">
.ds-filter {
    .loader {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        background-color: #fff;
        z-index: 99;
        border-radius: 0.5rem;
    }

    .v-select {
        background-color: #fff;

        input {
            &::placeholder {
                font-family: "Montserrat", Helvetica, Arial, sans-serif;
                font-size: .85rem !important;
            }
        }
    }

    .selected {
        .vs__clear {
            display: block !important;
        }
    }

    .vs__dropdown-option--disabled {
        background-color: #f6f6f6;
        color: rgba(0, 0, 0, 0.28) !important;
    }

    .notClear {
        .vs__selected {
            .vs__deselect {
                display: none !important;
            }
        }
    }
}
</style>
